import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Tracks pageviews with search params encoded into the pathname so
 * different filter combinations show as distinct entries in Umami's
 * "Pages" view. By default Umami splits URLs on `?` into
 * `url_path` / `url_query` columns and aggregates Pages by `url_path`
 * only, which means `/items?brand=samsung` and `/items?brand=lg`
 * collapse into a single `/items` row.
 *
 * This hook replaces the leading `?` with `/q:` so the full URL
 * becomes the pathname from Umami's perspective, preserving the raw
 * search params for analysis without the aggregation.
 */
export function useUmamiPageviewTracking() {
  const url = useRouterState({
    select: (s) => {
      const { pathname, searchStr } = s.location;
      if (!searchStr || searchStr === '?') return pathname;
      return `${pathname}/q:${searchStr.slice(1)}`;
    },
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.umami) return;
    window.umami.track((props) => ({ ...props, url }));
  }, [url]);
}
